import React, { useState, useEffect, useRef } from 'react';
// import { fetchAllPromisedData } from '../../../../common/utils/methods/commonMethods/utilityMethod';
// import { endpoint } from '../../../../common/constant';
// import ALoader from '../../../../common/a-loader';
import { Card, CardBody } from 'reactstrap';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ALoader from 'views/pages/manage/common/a-loader';
// import { getDropdowns } from './utils';
import ListComponent from './ListComponent';
import { endpoint } from '../../../../../manage/common/constant';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import moment from 'moment';
import { getAuditDetails } from '../common';
import {getDropdowns } from './constant';
import { processRowList } from '../constant';
import { updateRequest } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
const TaxMapping = ({
    buId,
    selectedTabValue,
    action='view'
}) => {

    const [rows, setRows] = useState([]);
    const ref= useRef()
    const [loader, setLoader] = useState(false)
    const [dropdowns, setDropdowns] = useState({})
     //const [dropdowns, setDropdowns] = useState({})

    // const fetchCSCMappingData = async () => {
    //     try {
    //         setRows(prev => ({ ...prev, fetching: true }));
    //         const resp = await fetchAllPromisedData(`${endpoint.receiptIndex.getReceiptIndices}/${buId}`, true);
    //         if (resp?.code === 200) {
    //             const data = resp?.data?.map((el, idx) => ({ ...el, srNo: idx + 1 }))
    //             setRows(prev => ({ ...prev, data }));
    //         }
    //     } catch (err) {
    //         console.error(err);
    //     } finally {
    //         setRows(prev => ({ ...prev, fetching: false }));
    //     }
    // }

    useEffect(() => {
         buId && selectedTabValue?.key=='taxMapping' && init();
    }, [buId, selectedTabValue?.key])
    
  const init = async () => {
        try {
            setLoader(true)
            const dropdown = await getDropdowns()
            await getTaxMappingList(dropdown)

            setDropdowns(dropdown)
            setDropdowns((prev) => ({ ...prev, ...dropdown }))
        }
        catch (err) {
            console.error(err)
        }
        finally {
            setLoader(false)
        }
    }

        const getTaxMappingList= async(dropdown=dropdowns)=>{
            try{
                setLoader(true)
            const url= `${endpoint.taxMapping.get}/${buId}`
            const data= await fetchAllPromisedData(url)
            const rowList= processRowList(data,dropdown)
            setRows(rowList.map((item,index)=>({...item,srNo:index+1})))
            }
            catch(err){
                console.log(err)
            }
            finally{
                setLoader(false)
            }
        }
    const createUpdateHandler = async (rowForm) => {
            try {
                setLoader(true);
                const reqObj = {
                    ...rowForm,
                    businessAreaId: buId,
                    effectiveDate:moment(rowForm?.effectiveDate).format('YYYY-MM-DD')
                }
                let url = endpoint.taxMapping.create;
                let method = 'post';
    
                if (!rowForm?.isNew) {
                    url = `${endpoint.taxMapping.update}/${reqObj?.id}`;
                    method = 'put'
                }
                const resp = await fetchAllPostPromisedData(url, updateRequest(reqObj), method);
                if (resp?.code === 200) {
                    getTaxMappingList();
                    successToast('Request completed successfully!!!')
                    ref.current.stopEditing();
                }
            } catch (err) {
                console.log(err);
            }
            finally{
                setLoader(false)
            }
        }

    if (selectedTabValue?.id !== 9) return null;

    return (
        <>
            <Card className='ml-0'>
                <CardBody>
                    <div className='d-flex justify-content-between mx-2 my-3'>
                    <div className='large-text color-grey-80'>Tax Mapping</div>
                    {action!='view'&&

                        <AButton
                            variant='primary_filled'
                            onClick={() => ref.current.addNewRow()}
                            size='xs'
                        >
                            + Create new
                        </AButton>
                    }
                    </div>
                    <div style={{border:'1px solid #E2E2E2'}}>
                    <ListComponent
                        rows={rows}
                        ref={ref}
                        dropdowns={dropdowns}
                        createUpdateHandler={createUpdateHandler}
                        loading={loader}
                        // setDropdowns={setDropdowns}
                    />
                    </div>
                    {rows.length>0&&getAuditDetails(rows[0].updatedBy,rows[0].updatedOn)}
                </CardBody>

            </Card>
        </>
    );
}

export default TaxMapping;